import React from 'react';
import BlogBody from '../component/BlogBody';
import '../style/index.css';

function Blog() {
    return (
        <div>
            <BlogBody />
        </div>
    );
}

export default Blog;
